import { useTheme } from "../Context/ThemeContext";

import EditIcon from "../assets/images/Edit.svg";
import EditIconDark from "../assets/images/Edit_Dark.svg";
import AddIcon from "../assets/images/Add.svg";
import AddIconDark from "../assets/images/Add_Dark.svg";
import DeleteIcon from "../assets/images/Delete.svg";
import DeleteIconDark from "../assets/images/Delete_Dark.svg";
import DarkModeMoon from "../assets/images/Dark_mode_Moon.svg";
import DarkModeSun from "../assets/images/Sun_icon_dark.svg";
import LogoutIcon from "../assets/images/Logout.svg";
import LogoutIconDark from "../assets/images/DarkLogOut.svg";
import NexusLogo from "../assets/images/NEXUS_LightMode_Logo.svg";
import NexusLogoDark from "../assets/images/NEXUS_DarkMode_Logo.svg";
import PeopleDark from "../assets/images/People_Dark.svg";
import PeopleLight from "../assets/images/People_Light.svg";

const ICONS = () => {
  const { isDarkMode } = useTheme();

  const icons = isDarkMode
    ? {
        EditIcon: EditIconDark,
        AddIcon: AddIconDark,
        DeleteIcon: DeleteIconDark,
        DarkModeMoon: DarkModeSun,
        LogoutIcon: LogoutIconDark,
        NexusLogo: NexusLogoDark,
        People: PeopleDark
      }
    : {
        EditIcon: EditIcon,
        AddIcon: AddIcon,
        DeleteIcon: DeleteIcon,
        DarkModeMoon: DarkModeMoon,
        LogoutIcon: LogoutIcon,
        NexusLogo: NexusLogo,
        People: PeopleLight
      };

  return icons;
};
export default ICONS;
